import { render, staticRenderFns } from "./VimeoIframe.vue?vue&type=template&id=1e59058e&"
import script from "./VimeoIframe.vue?vue&type=script&lang=js&"
export * from "./VimeoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports